import { useMemo, useState } from 'react';
import { Lead } from '../../../../models/Leads';
import TemplateModalContext from './TemplateModalContext';

// @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const TemplateModalContextProvider = ({ children, modalId }) => {
  const [lead, setLead] = useState<Lead>();
  const [messageContent, setMessageContent] = useState<HTMLElement>();

  const contextValue = useMemo(
    () => ({
      lead,
      modalId,
      messageContent,
      setLead,
      setMessageContent,
    }),
    [lead, modalId, messageContent],
  );

  return (
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    <TemplateModalContext.Provider value={contextValue}>
      {children}
    </TemplateModalContext.Provider>
  );
};

export default TemplateModalContextProvider;
